document.addEventListener('theme:variant:change', function(e) {
  const variant = e.detail.variant;
  if (!variant) return;

  const dataEl = document.getElementById('variants-preorder-data');
  if (!dataEl) return;

  const data = JSON.parse(dataEl.textContent || '{}');
  const el = document.getElementById('preorder-message');
  if (!el) return;

  const msg = data[variant.id];
  el.textContent = msg || '';
  el.style.display = msg ? 'block' : 'none';
});
